import React from 'react';

import Table from './Table';
import TableHead from './TableHead';
import TableRow from './TableRow';
import TableCollapsedRow from './TableCollapsedRow';
import TableCell from './TableCell';
import TableBody from './TableBody';
import TableFoot from './TableFoot';

import { ReportTableType } from '../../types/ReportTableType';

import { REPORTS_TABLES_COLUMNS } from '../../constants/ReportsTablesColumns';
import { ScrollableContent } from '../Layout';

interface ClassificationsReportTableProps {
    reportType: ReportTableType;
    headerTableData?: { key: string; title: string; minWidth: number; maxWidth: number }[];
    bodyTableData: Record<string, any>[];
    footerTableData?: number;
}

const ClassificationsReportTable: React.FC<ClassificationsReportTableProps> = (props) => {
    const { reportType, bodyTableData } = props;

    const [classificationsTotalSum, setClassificationsTotalSum] = React.useState<number>(0);

    React.useEffect(() => {
        if (bodyTableData && bodyTableData.length > 0) {
            let totalSum = 0;
            bodyTableData.forEach((row) => {
                totalSum += row.totalExclVat;
            });
            setClassificationsTotalSum(totalSum);
        }
    }, [bodyTableData]);

    return (
        <ScrollableContent>
            <Table additionalClasses="is-striped is-hoverable is-fullwidth">
                <TableHead>
                    <TableRow>
                        {REPORTS_TABLES_COLUMNS[reportType].map((column) => (
                            <TableCell
                                key={column.key}
                                type="head"
                                draggable={false}
                                additionalClasses={column.additionalClasses}
                            >
                                <div className="th-wrap is-relative">{column.title}</div>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                {bodyTableData && bodyTableData.length > 0 ? (
                    <React.Fragment>
                        <TableBody>
                            {bodyTableData.map((row) => (
                                <TableCollapsedRow
                                    key={row.classificationCode}
                                    additionalClasses="has-background-grey-lighter"
                                    appendedChild={{ childCellType: 'body', childCellData: row.classificationCode }}
                                    collapsedRowChildData={row.classificationChildren}
                                >
                                    <TableCell type="body" draggable={false}>
                                        {row.classificationTitle.fr}
                                    </TableCell>
                                    <TableCell type="body" draggable={false}>
                                        {row.classificationUnit}
                                    </TableCell>
                                    <TableCell type="body" draggable={false} additionalClasses="has-text-right">
                                        {row.totalExclVat.toLocaleString('fr-FR', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}{' '}
                                        €
                                    </TableCell>
                                </TableCollapsedRow>
                            ))}
                        </TableBody>

                        <TableFoot>
                            <TableRow additionalClasses="table-footer has-background-light">
                                <TableCell type="foot" additionalClasses="is-hidden-mobile">
                                    <div className="th-wrap is-numeric">{null}</div>
                                </TableCell>
                                <TableCell type="foot" additionalClasses="is-hidden-mobile">
                                    <div className="th-wrap">Total</div>
                                </TableCell>
                                <TableCell type="foot" additionalClasses="is-hidden-mobile">
                                    <div className="th-wrap is-numeric">{null}</div>
                                </TableCell>
                                <TableCell type="foot" additionalClasses="has-text-right">
                                    <div>
                                        {classificationsTotalSum?.toLocaleString('fr-FR', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}{' '}
                                        €
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableFoot>
                    </React.Fragment>
                ) : null}
            </Table>
        </ScrollableContent>
    );
};

export default ClassificationsReportTable;
